module.exports = __webpack_public_path__ + "img/food-19.165b6d9a.jpg";